import React, { useState, useEffect } from 'react'
import Contact from './style'
import SectionTitle from './Components/SectionTitle'
import { StaticImage as Img } from "gatsby-plugin-image";
import HeroImageGroup from '~sections/it/Hero/Components/ImageGroup/style'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import client from "~data/contentful"
import 'regenerator-runtime/runtime'

const generateUuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export default function EarlyAccess(props) {
    const [success, setSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestId, setRequestId] = useState('');
    const [error, setError] = useState('');
    const [name, setName] = useState('');
    

    const isEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const isPhone = (phone) => {
        const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return re.test(phone);
    };

    const validateForm = (values) => {
        const errors = {};
        if (!values.firstName) {
            errors.firstName = 'Please enter your firstname';
        }
        if (!values.lastName) {
            errors.lastName = 'Please enter your lastname';
        }
        if (!values.email) {
            errors.email = 'Please enter your email';
        }
        if (!values.phone) {
            errors.phone = 'Please enter your phone number';
        }
        if (isEmail(values.email) === false) {
            errors.email = 'Please enter a valid email';
        }
        if (isPhone(values.phone) === false) {
            errors.phone = 'Please enter a valid phone number';
        }
        return errors;
    };

    const submitEarlyAccess = (e) => {
        e.preventDefault()
        const values = {
            email: document.querySelector('#email').value,
            firstName: document.querySelector('#firstName').value,
            lastName: document.querySelector('#lastName').value,
            phone: document.querySelector('#phone').value,
        }
        const errors = validateForm(values);
        if (Object.keys(errors).length > 0) {
            setError(errors);
            return;
        }
        setName(values.firstName)
        setIsSubmitting(true)
        const uuid = generateUuidv4()
        client.getSpace('s5z6ubc8fuk6')
            .then((space) => space.getEnvironment('master'))
            .then((environment) => environment.createEntryWithId('earlyAccess', uuid, {
                fields: {
                    firstname: {
                        'en-US': values.firstName
                    },
                    lastname: {
                        'en-US': values.lastName
                    },
                    phone: {
                        'en-US': values.phone
                    },
                    email: {
                        'en-US': values.email
                    }
                }
            }))
            .then((entry) => {
                client.getSpace('s5z6ubc8fuk6')
                    .then((space) => space.getEnvironment('master'))
                    .then((environment) => environment.getEntry(entry.sys.id))
                    .then((entry) => entry.publish())
                    .then((entry) => {
                        setSuccess(true)
                        setRequestId(entry.sys.id)
                    })
                    .catch(() => {
                        setSuccess(false)
                        setIsSubmitting(false)
                    })
            })
            .catch(() => {
                setSuccess(false)
                setIsSubmitting(false)
            })
    }

    const renderForm = () => {
        return (
            <div>
                <Contact.Box >
                    <SectionTitle
                        title="Join us in our journey."
                        text="Sign up to get early access before it is available to public."
                        subTitleProps={{ mb: "10px" }}
                        titleProps={{ mb: "10px", as: "h2" }}
                        mb="50px" />
                </Contact.Box>
                <Contact.From>
                    <form action="./">
                        <Row>
                            <Col xs="12" className="col-lg-6 mb-4">
                                <div className="form-floating">
                                    <input className="form-control" placeholder="Your first name" id="firstName" />
                                    <label htmlFor="floatinginput">First Name</label>
                                </div>
                                {error.firstName && <Contact.Error>{error.firstName}</Contact.Error>}
                            </Col>
                            <Col xs="12" className="col-lg-6 mb-4">
                                <div className="form-floating">
                                    <input className="form-control" placeholder="Your last name" id="lastName" />
                                    <label htmlFor="floatinginput2">Last Name</label>
                                </div>
                                {error.lastName && <Contact.Error>{error.lastName}</Contact.Error>}
                            </Col>
                            <Col xs="12" className="col-lg-6 mb-4">
                                <div className="form-floating">
                                    <input className="form-control" placeholder="Enter your email" id="email" />
                                    <label htmlFor="floatinginput">Your Email</label>
                                </div>
                                {error.email && <Contact.Error>{error.email}</Contact.Error>}
                            </Col>
                            <Col xs="12" className="col-lg-6 mb-4">
                                <div className="form-floating">
                                    <input className="form-control" placeholder="Enter your phone number" id="phone" />
                                    <label htmlFor="floatinginput2">Phone number</label>
                                </div>
                                {error.phone && <Contact.Error>{error.phone}</Contact.Error>}
                            </Col>
                            <Col xs="12" className="col-lg-12">
                                <Row className="align-items-center mt-3">
                                    <div className="col-md-8 col-lg-7 col-md-6 col-xl-8 pt-3">
                                    </div>
                                    <Col xs="12" className="col-md-4 col-lg-5 col-xl-4 text-md-end pt-3">
                                        <Contact.Button onClick={submitEarlyAccess} disabled={isSubmitting}>
                                            {isSubmitting ? <Spinner animation="border" variant="light" /> : 'Request Early Access'}
                                        </Contact.Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </form>
                </Contact.From>
            </div>
        )
    }

    const successMessage = () => {
        return (
            <div>
                <Contact.Box >
                    <SectionTitle
                        title={`Thank you, ${name}`}
                        text={`Our team will get in touch with you shortly. Your support request id is ${requestId}`}
                        subTitleProps={{ mb: "10px" }}
                        titleProps={{ mb: "10px", as: "h2" }}
                        mb="50px" />
                </Contact.Box>
                <div>
                    <Img src="../../../../assets/image/project-management/thankyou.png" alt="heroimg" placeholder="blurred" />
                </div>
            </div>
        )
    }
                        


    return (
        <Contact backgroundColor="#f3f4f6">
            <Container>
                <Row>
                    <Col className="col-xl-7 col-lg-7">
                        {success ? successMessage() : renderForm()}
                    </Col>
                    <Col xs="12" className="col-xl-5 col-lg-5">
                        <HeroImageGroup>
                            <HeroImageGroup.ImagesList>
                                <HeroImageGroup.ImageOne>
                                    <Img src="../../../../assets/image/project-management/early-access.png" alt="heroimg" layout="fullWidth" placeholder="blurred" />
                                </HeroImageGroup.ImageOne>
                            </HeroImageGroup.ImagesList>
                        </HeroImageGroup>
                    </Col>
                </Row>
            </Container>
        </Contact>
    )
}